import { render, staticRenderFns } from "./TitleSynopsis.vue?vue&type=template&id=a4331632&scoped=true"
import script from "./TitleSynopsis.vue?vue&type=script&lang=ts"
export * from "./TitleSynopsis.vue?vue&type=script&lang=ts"
import style0 from "./TitleSynopsis.vue?vue&type=style&index=0&id=a4331632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4331632",
  null
  
)

export default component.exports